import React, { CSSProperties, useRef } from 'react'
import Slider from 'react-slick'
import { GalleryItemType } from '../../containers/LessonPage/types'
import '@fancyapps/ui/src/Fancybox'

// Styles
import './styles.scss'
import '@fancyapps/ui/dist/fancybox.css'
import './fancybox.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './slick.scss'

// Icons
import IconLeft from './images/iconLeft'
import IconRight from './images/iconRight'

export default ({
  style,
  gallery,
}: {
  style: CSSProperties
  gallery?: GalleryItemType[]
}) => {
  if (!gallery?.length) return <></>

  const refSlider = useRef<any>(null)

  const offsets = ['one', 'two', 'three']

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: gallery.length > 4 ? 4 : gallery.length,
    slidesToScroll: 4,
    arrows: true,
    nextArrow: <IconRight />,
    prevArrow: <IconLeft />,
    className: gallery.length < 4 ? offsets[gallery.length - 1] : '',
  }

  return (
    <div className={'gallery'} style={style}>
      <Slider ref={refSlider} {...settings}>
        {gallery.map(image => (
          <a
            key={image.media_file_id}
            data-fancybox="gallery"
            href={image.file.url}
            className={'item'}
          >
            <img src={image.file.url} />
          </a>
        ))}
      </Slider>
    </div>
  )
}
